import { styled } from 'styled-components';

import PasswordSVG from '../assets/password-icon.svg?react';

export const StyledPasswordIcon = styled(PasswordSVG)`
  width: 24px;
  height: 24px;
`;
